module.exports = __webpack_public_path__ + "static/media/eye.e4c01c39.png";